import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation, Trans } from "react-i18next";
import SectionMainTitle from "../components/SectionMainTitle";
import SectionPageHeader from "../components/SectionPageHeader";
import SectionCompatibilityTest from "../components/SectionCompatibilityTest";
import SectionPricing from "../components/SectionPricing";
import BaseButton from "../../../components/BaseButton";
import GradientCheck from "../../../assets/icons/gradient_check.svg";
import AuthorOnChair from "../../../assets/images/author_on_chair.png";
import JoinedCouplesImgEn from "../../../assets/images/joined_couples_en.png";
import FaceButterfly from "../../../assets/images/bg_bf_13.png";
import JoinedCouplesImgRu from "../../../assets/images/joined_couples_ru.png";
import JoinedCouplesMImgEn from "../../../assets/images/joined_couples_m_en.png";
import JoinedCouplesMImgRu from "../../../assets/images/joined_couples_m_ru.png";
import HowIntouchWorksRu from "../../../assets/images/how-intouch-works-ru.png";
import HowIntouchWorksRu1 from "../../../assets/images/how-intouch-works1-ru.png";
import HowIntouchWorksEn from "../../../assets/images/how-intouch-works-en.png";
import HowIntouchWorksEn1 from "../../../assets/images/how-intouch-works1-en.png";
import IsBestOptionImgEn from "../../../assets/images/is_best_option_en.png";
import IsBestOptionImgRu from "../../../assets/images/is_best_option_ru.png";
import DownloadAppImgEn from "../../../assets/images/download_app_en.png";
import DownloadAppImgRu from "../../../assets/images/download_app_ru.png";
import CheckMarkImg from "../../../assets/images/check-mark.png";
import SlideDownArrowIcon from "../../../assets/icons/slide-down-arrow.svg";
import QuotesIcon from "../../../assets/icons/quotes.svg";
import DownloadAndroidImg from "../../../assets/images/download_android.png";
import DownloadAppStoreImg from "../../../assets/images/download_app_store.png";
import ROUTES from "../../../utils/routes";
import useController from "./controller";

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1.35,
  slidesToScroll: 1,
  centerPadding: "5%",
  centerMode: true,
};

export default function LandingContent() {
  const { t, i18n } = useTranslation();
  const { startDemoGame, isDemoGameLoading, buyGame } = useController();
  return (
    <>
      <SectionPageHeader />
      <SectionCompatibilityTest
        onStartTest={startDemoGame}
        isLoading={isDemoGameLoading}
      />
      <SectionMainTitle />

      <section className="section-innovate-tool">
        <div className="section-title">
          <div className="eclipse eclipse-1"></div>
          <div
            className="neon-text"
            data-text={t("section_innovate_tool.innovate_tool")}
          >
            {t("section_innovate_tool.innovate_tool")}
          </div>
        </div>
        <div className="subtitle">
          {/* .subtitle — flex-контейнер: оборачиваем в один <span>, чтобы текст и
              <u>а именно:</u> были одним flex-айтемом и текли инлайном, а не двумя колонками */}
          <span>
            <Trans
              i18nKey="section_innovate_tool.innovate_tool_subtitle"
              components={{ u: <u /> }}
            />
          </span>
        </div>
        <div className="points">
          <div className="point">
            <img loading="lazy" src={CheckMarkImg} />
            {t("section_innovate_tool.point1")}
          </div>
          <div className="point">
            <img loading="lazy" src={CheckMarkImg} />
            {t("section_innovate_tool.point2")}
          </div>
          <div className="point">
            <img loading="lazy" src={CheckMarkImg} />
            {t("section_innovate_tool.point3")}
          </div>
          <div className="point">
            <img loading="lazy" src={CheckMarkImg} />
            {t("section_innovate_tool.point4")}
          </div>
          <div className="point">
            <img loading="lazy" src={CheckMarkImg} />
            {t("section_innovate_tool.point5")}
          </div>
          <div className="point">
            <img loading="lazy" src={CheckMarkImg} />
            {t("section_innovate_tool.point6")}
          </div>
        </div>
      </section>

      <section className="section-moreover">
        <div
          className="section-title neon-text"
          data-text={t("section_moreover.title")}
        >
          {t("section_moreover.title")}
        </div>
        <div className="points">
          <div className="point">
            <img loading="lazy" className="small" src={CheckMarkImg} />
            {t("section_moreover.point1")}
          </div>
          <div className="point">
            <img loading="lazy" className="small" src={CheckMarkImg} />
            {t("section_moreover.point2")}
          </div>
          <div className="point">
            <img loading="lazy" className="small" src={CheckMarkImg} />
            {t("section_moreover.point3")}
          </div>
          <div className="point">
            <img loading="lazy" className="small" src={CheckMarkImg} />
            {t("section_moreover.point4")}
          </div>
          <div className="point">
            <img loading="lazy" className="small" src={CheckMarkImg} />
            {t("section_moreover.point5")}
          </div>
          <div className="point center down-arrow">
            <img loading="lazy" src={SlideDownArrowIcon} />
          </div>
        </div>
        <div className="footer-text">
          <Trans
            i18nKey="section_moreover.footer"
            components={{ u: <u /> }}
          />
        </div>
      </section>

      <section className="section-how-in-touch-works">
        <div
          className="section-title neon-text"
          data-text={t("section_game_how_intouch_works.title")}
        >
          {t("section_game_how_intouch_works.title")}
        </div>
        <div className="section-how-in-touch-works__container">
          <div className="section-how-in-touch-works__step-wrapper">
            <div className="section-how-in-touch-works__step section-how-in-touch-works__step_first">
              <div className="section-how-in-touch-works__step-header">
                <div className="section-how-in-touch-works__step-title">
                  {t("section_game_how_intouch_works.step1.title")}
                </div>
                <div className="section-how-in-touch-works__step-text">
                  {t("section_game_how_intouch_works.step1.text")}
                </div>
              </div>
              <div className="section-how-in-touch-works__card section-how-in-touch-works__card_first">
                <img
                  src={
                    i18n.language === "en"
                      ? HowIntouchWorksEn
                      : HowIntouchWorksRu
                  }
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="section-how-in-touch-works__step-wrapper">
            <div className="section-how-in-touch-works__step section-how-in-touch-works__step_second">
              <div className="section-how-in-touch-works__step-header">
                <div className="section-how-in-touch-works__step-title">
                  {t("section_game_how_intouch_works.step2.title")}
                </div>
                <div className="section-how-in-touch-works__step-text">
                  {t("section_game_how_intouch_works.step2.text")}
                </div>
              </div>
              <div className="section-how-in-touch-works__card section-how-in-touch-works__card_second">
                <img
                  src={
                    i18n.language === "en"
                      ? HowIntouchWorksEn1
                      : HowIntouchWorksRu1
                  }
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-what-is-insight">
        <div className="section-what-is-insight__wrapper">
          <div className="gradient-border-wrapper">
            <div className="card first">
              <div className="section-what-is-insight__face-butter">
                <img src={FaceButterfly} alt="" />
              </div>
              <div
                className="section-title neon-text"
                data-text={t("what_is_insight_form.left.title")}
              >
                {t("what_is_insight_form.left.title")}
              </div>
              <div className="section-what-is-insight__left-text">
                {t("what_is_insight_form.left.text1")}
              </div>
              <div className="section-what-is-insight__left-text">
                {t("what_is_insight_form.left.text2")}
              </div>
            </div>
          </div>
          <div className="gradient-border-wrapper">
            <div className="card second">
              <div className="eclipse eclipse-11"></div>
              <div
                className="section-title neon-text"
                data-text={t("what_is_insight_form.right.title")}
              >
                {t("what_is_insight_form.right.title")}
              </div>
              <div className="section-what-is-insight__right-subtitle">
                {t("what_is_insight_form.right.subtitle")}
              </div>
              <div className="section-what-is-insight__right-item">
                <div>
                  <img src={GradientCheck} alt="" />
                </div>
                <div className="section-what-is-insight__right-item-desc">
                  <div className="section-what-is-insight__right-item-title">
                    {t("what_is_insight_form.right.title1")}
                  </div>
                  <div className="section-what-is-insight__right-item-text">
                    {t("what_is_insight_form.right.text1")}
                  </div>
                </div>
              </div>
              <div className="section-what-is-insight__right-item">
                <div>
                  <img src={GradientCheck} alt="" />
                </div>
                <div className="section-what-is-insight__right-item-desc">
                  <div className="section-what-is-insight__right-item-title">
                    {t("what_is_insight_form.right.title2")}
                  </div>
                  <div className="section-what-is-insight__right-item-text">
                    {t("what_is_insight_form.right.text2")}
                  </div>
                </div>
              </div>
              <div className="section-what-is-insight__right-item">
                <div>
                  <img src={GradientCheck} alt="" />
                </div>
                <div className="section-what-is-insight__right-item-desc">
                  <div className="section-what-is-insight__right-item-title">
                    {t("what_is_insight_form.right.title3")}
                  </div>
                  <div className="section-what-is-insight__right-item-text">
                    {t("what_is_insight_form.right.text3")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-what-is-insight__result">
          {t("what_is_insight_form.result")}
        </div>
      </section>

      <section className="section-game-goal">
        <div
          className="section-title neon-text"
          data-text={t("section_game_goal.title")}
        >
          {t("section_game_goal.title")}
        </div>
        <div className="block-container">
          <div className="block neon-box">
            <div className="eclipse eclipse-3"></div>
            <div className="eclipse eclipse-4"></div>
            {t("section_game_goal.block")}
          </div>
        </div>
      </section>

      <section className="section-intouch-author">
        <div className="section-intouch-author__container">
          <div>
            <img src={QuotesIcon} alt="" />
          </div>
          <div className="section-intouch-author__text">
            <div>
              <span className="section-intouch-author__intouch">Wepurplay</span>
              {t("section_intouch_author.text1")}
            </div>
            <div>{t("section_intouch_author.text2")}</div>
          </div>
        </div>
        <div className="section-intouch-author__wrapper">
          <div className="section-intouch-author__author">
            <div>
              <div className="eclipse eclipse-author"></div>
              <img src={AuthorOnChair} alt="" />
            </div>
            <div>{t("section_intouch_author.author")}</div>
          </div>
        </div>
      </section>

      <section className="section-is-best-option">
        <div className="gradient-border-wrapper">
          <div className="card first">
            <div
              className="neon-text"
              data-text={t("section_is_best_option.title")}
            >
              {t("section_is_best_option.title")}
            </div>
            <div
              className="section-title neon-text"
              data-text={t("section_is_best_option.name_game")}
            >
              <div className="eclipse eclipse-10"></div>
              {t("section_is_best_option.name_game")}
            </div>
            <img
              loading="lazy"
              className="d-md-none"
              src={
                i18n.language == "ru" ? IsBestOptionImgRu : IsBestOptionImgEn
              }
            />
          </div>
        </div>
        <div className="gradient-border-wrapper">
          <div className="card second">
            <div className="eclipse eclipse-11"></div>
            <div className="eclipse eclipse-12"></div>
            <div className="section-is-best-option__text">
              <div className="title">
                {t("section_is_best_option.card1_title")}
              </div>
              <div className="desc">
                {t("section_is_best_option.card1_desc")}
              </div>
            </div>
            <div className="section-is-best-option__text">
              <div className="title">
                {t("section_is_best_option.card2_title")}
              </div>
              <div className="desc">
                {t("section_is_best_option.card2_desc")}
              </div>
            </div>
            <div className="section-is-best-option__text">
              <div className="title">
                {t("section_is_best_option.card3_title")}
              </div>
              <div className="desc">
                {t("section_is_best_option.card3_desc")}
              </div>
            </div>
            <div className="section-is-best-option__text">
              <div className="title">
                {t("section_is_best_option.card4_title")}
              </div>
              <div className="desc">
                {t("section_is_best_option.card4_desc")}
              </div>
            </div>
            <img
              loading="lazy"
              className="d-none d-md-block center is-best-option-img-m"
              src={
                i18n.language == "ru" ? IsBestOptionImgRu : IsBestOptionImgEn
              }
            />
          </div>
        </div>
      </section>

      <section className="section-still-here">
        <div className="eclipse eclipse-13"></div>
        <div className="eclipse eclipse-14"></div>
        <p>{t("section_still_here.desc1")}</p>
        <p>{t("section_still_here.desc2")}</p>
      </section>

      <SectionPricing onBuy={buyGame} />

      <section className="section-joined-couples">
        <div
          className="section-title neon-text"
          data-text={t("section_joined_couples.title")}
        >
          <div className="eclipse eclipse-5"></div>
          {t("section_joined_couples.title")}
        </div>
        <div className="subtitle neon-text-secondary">
          {t("section_joined_couples.subtitle")}
        </div>
        <div className="desc">{t("section_joined_couples.desc")}</div>
        <div>
          <img
            className="w-100 d-md-none"
            loading="lazy"
            src={
              i18n.language == "ru" ? JoinedCouplesImgRu : JoinedCouplesImgEn
            }
          />
          <img
            className="center d-none d-md-block joined-couples-img-m"
            loading="lazy"
            src={
              i18n.language == "ru" ? JoinedCouplesMImgRu : JoinedCouplesMImgEn
            }
          />
        </div>
      </section>

      <section className="section-compatibility">
        <div className="section-compatibility__title">
          {t("section_compatibility.title")}
        </div>
        <div className="section-compatibility__text">
          {t("section_compatibility.text")}
        </div>
        <BaseButton
          loading={isDemoGameLoading}
          onClick={startDemoGame}
          iconWrapperStyle="section-main-title__log-in-icon-wrapper"
          className="section-compatibility__button"
        >
          {t("section_compatibility.start")}
        </BaseButton>
      </section>

      <section className="section-app-download">
        <div className="gradient-border-wrapper">
          <div className="block">
            <div className="eclipse eclipse-17"></div>
            <div className="eclipse eclipse-18"></div>
            <div className="left-wrapper">
              <div
                className="title neon-text"
                data-text={t("section_app_download.title")}
              >
                {t("section_app_download.title")}
              </div>
              <div className="download-links">
                <BaseButton to="https://apps.apple.com/us/app/in-touch-app/id6472431857">
                  <img loading="lazy" src={DownloadAppStoreImg} />
                </BaseButton>
                <BaseButton
                  native
                  href="/application/android/"
                >
                  <img loading="lazy" src={DownloadAndroidImg} />
                </BaseButton>
              </div>
              <img
                loading="lazy"
                className="d-none d-md-block app-m-img"
                src={
                  i18n.language == "ru" ? DownloadAppImgRu : DownloadAppImgEn
                }
              />
              <div>
                <BaseButton
                  to={ROUTES.SUPPORT_PAGE}
                  name="login"
                  className="section-app-download__support-btn"
                >
                  {t("section_app_download.button_support")}
                </BaseButton>
              </div>
            </div>
            <div className="right-wrapper"></div>
          </div>
        </div>
        <div className="img">
          <img
            loading="lazy"
            className="d-md-none"
            src={i18n.language == "ru" ? DownloadAppImgRu : DownloadAppImgEn}
          />
        </div>
      </section>
    </>
  );
}
